import {getIsServer} from './getIsServer';

export const getBaseRemSize = () => {
    if (getIsServer()) {
        return 16;
    }
    return parseFloat(
        window.getComputedStyle(document.documentElement).fontSize,
    );
};
